import React from "react";
import "./about.css";

function Aboutus() {
  return (
    <div>
      <section className="heor">
        {/* <div className="heading">
          <h1>about us</h1>
        </div> */}
        <div className="container1">
          <div className="hero-content">
            <h2>Welcome to HeyGirl!</h2>
            <p>
              Hey Girl! Is non-profit making organization that shall mentor
              girls and help them overcome personal challenges that affect them
              to stay in school. This is to help deal with school dropout rate
              of girls especially in primary school where education is for free.
            </p>
            <button className="cta-button"> learn more</button>
          </div>
          <div className="hero-img">
            <img src="./assets/students.jpg"></img>
          </div>
        </div>
      </section>
      <div className="container2">
        <div className="service-wrapper">
          <div className="service">
            <h1>Goals</h1>
            <div className="cards">
              <div className="cardi">
                <i className="fa fa-book"></i>
                <h3>Our Mission</h3>
                <p>
                  To mentor and empower girls by providing them with the
                  necessary support, guidance, and resources to achieve their
                  full potential academically, personally, and professionally.
                </p>
              </div>
              <div className="cardi">
                <i className="fa fa-globe"></i>
                <h3>Our Vision</h3>
                <p>
                  To provide one on one mentorship program that will involve
                  proper follow up and build close contact with girls to
                  motivate, empower and provide them counseling to meet their
                  emotional needs through letter writing and use of an
                  application for those that have access to the internet.
                </p>
              </div>
              <div className="cardi">
                <i className="fa fa-pencil"></i>
                <h3>Achievements</h3>
                <hr />
                <p>
                  lorem Girl! Is non-profit This is to help deal with school
                  dropout rate of girls
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div id="about" className="heor">
        <div id="about-1"></div>
        <div id="about-2">
          <div className="content-box-lg">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <div className="about-item text-center">
                    <i className="fa fa-book"></i>
                    <h3>Mission</h3>
                    <hr />
                    <p>
                      Hey Girl! Is non-profit making organization that shall
                      mentor girls and help them overcome personal challenges
                      that affect them to stay in school. This is to help deal
                      with school dropout rate of girls
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="about-item text-center">
                    <i className="fa fa-globe"></i>
                    <h3>Vision</h3>
                    <hr />
                    <p>
                      Hey Girl! Is non-profit making organization that shall
                      mentor girls and help them overcome personal challenges
                      that affect them to stay in school. This is to help deal
                      with school dropout rate of girls
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="about-item text-center">
                    <i className="fa fa-pencil"></i>
                    <h3>Achievements</h3>
                    <hr />
                    <p>
                      Hey Girl! Is non-profit making organization that shall
                      mentor girls and help them overcome personal challenges
                      that affect them to stay in school. This is to help deal
                      with school dropout rate of girls
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default Aboutus;
